var render = function render(){var _vm=this,_c=_vm._self._c;return _c('auth',[(_vm.is_loaded)?_c('div'):_c('loading')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }